"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EraSwapDaoFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var EraSwapDaoFactory = /** @class */ (function (_super) {
    __extends(EraSwapDaoFactory, _super);
    function EraSwapDaoFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    EraSwapDaoFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    EraSwapDaoFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    EraSwapDaoFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    EraSwapDaoFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    EraSwapDaoFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return EraSwapDaoFactory;
}(contracts_1.ContractFactory));
exports.EraSwapDaoFactory = EraSwapDaoFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'transactionId',
                type: 'uint256',
            },
        ],
        name: 'Confirmation',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'Deposit',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'transactionId',
                type: 'uint256',
            },
        ],
        name: 'Execution',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'transactionId',
                type: 'uint256',
            },
        ],
        name: 'ExecutionFailure',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'transactionId',
                type: 'uint256',
            },
        ],
        name: 'Revocation',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'transactionId',
                type: 'uint256',
            },
        ],
        name: 'Submission',
        type: 'event',
    },
    {
        inputs: [],
        name: 'dayswappers',
        outputs: [
            {
                internalType: 'contract IDayswappers',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bool',
                name: 'pending',
                type: 'bool',
            },
            {
                internalType: 'bool',
                name: 'executed',
                type: 'bool',
            },
        ],
        name: 'getTransactionCount',
        outputs: [
            {
                internalType: 'uint256',
                name: 'count',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'from',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'to',
                type: 'uint256',
            },
            {
                internalType: 'bool',
                name: 'pending',
                type: 'bool',
            },
            {
                internalType: 'bool',
                name: 'executed',
                type: 'bool',
            },
        ],
        name: 'getTransactionIds',
        outputs: [
            {
                internalType: 'uint256[]',
                name: '_transactionIds',
                type: 'uint256[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_staking',
                type: 'address',
            },
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
        ],
        name: 'getVotingPreviledge',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'kycDapp',
        outputs: [
            {
                internalType: 'contract IKycDapp',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'nrtManager',
        outputs: [
            {
                internalType: 'contract INRTManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'prepaidEs',
        outputs: [
            {
                internalType: 'contract IPrepaidEs',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'randomnessManager',
        outputs: [
            {
                internalType: 'contract RandomnessManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
        ],
        name: 'required',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'required',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
        ],
        name: 'resolveAddress',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
        ],
        name: 'resolveAddressStrict',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wallet',
                type: 'address',
            },
        ],
        name: 'resolveUsername',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wallet',
                type: 'address',
            },
        ],
        name: 'resolveUsernameStrict',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_kycDapp',
                type: 'address',
            },
        ],
        name: 'setKycDapp',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyClub',
        outputs: [
            {
                internalType: 'contract ITimeAllyClub',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyManager',
        outputs: [
            {
                internalType: 'contract ITimeAllyManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyPromotionalBucket',
        outputs: [
            {
                internalType: 'contract ITimeAllyPromotionalBucket',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'transactionCount',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'validatorManager',
        outputs: [
            {
                internalType: 'contract IValidatorManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        stateMutability: 'payable',
        type: 'receive',
    },
];
var _bytecode = '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';
//# sourceMappingURL=EraSwapDaoFactory.js.map